import React from "react";
import { classNames } from "src/helpers/classNames";

const BenefitsSection = ({ data }) => {
  return (
    <section className={classNames(data?.hidden ? "hidden" : "relative mx-auto mt-32 max-w-7xl px-6 sm:mt-56 lg:px-8")}>
      <div className="mx-auto max-w-2xl lg:text-center">
        <p className="mt-2 text-4xl font-semibold tracking-tight text-slate-900 [text-wrap:pretty] sm:text-5xl lg:[text-wrap:balance]">{data?.title}</p>
        <p className="mt-6 text-lg text-slate-500">{data?.description}</p>
      </div>
      {data?.benefits?.length > 0 && (
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {data?.benefits?.map((item, index) => (
              <div
                className="flex flex-col"
                key={index}>
                <dt className="flex items-center gap-x-3 text-base font-semibold text-slate-800">
                  <span
                    dangerouslySetInnerHTML={{ __html: item?.icon }}
                    className="h-5 w-5 flex-none text-indigo-500"
                  />
                  {item?.title}
                </dt>
                <dd className="mt-4 flex flex-auto flex-col text-base text-slate-500">
                  <div className="flex-auto">{item?.description}</div>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      )}
    </section>
  );
};

export default BenefitsSection;
